var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99995 9.8002L4.19995 9.8002C3.88169 9.8002 3.57647 9.67377 3.35142 9.44872C3.12638 9.22368 2.99995 8.91846 2.99995 8.6002L2.99995 5.6002L0.599951 2.60019L2.99995 2.6002L2.99995 1.4002C2.99995 1.08194 3.12638 0.77671 3.35142 0.551667C3.57647 0.326623 3.88169 0.200195 4.19995 0.200195L8.99995 0.200195C9.31821 0.200195 9.62344 0.326623 9.84848 0.551667C10.0735 0.776711 10.2 1.08194 10.2 1.4002L10.2 8.6002C10.2 8.91846 10.0735 9.22368 9.84848 9.44872C9.62344 9.67377 9.31821 9.8002 8.99995 9.8002ZM7.19995 3.2002L7.19995 2.0002L5.99995 2.0002L5.99995 3.2002L7.19995 3.2002ZM7.19995 4.4002L7.19995 5.6002L5.99995 5.6002L5.99995 4.4002L7.19995 4.4002ZM7.19995 8.0002L7.19995 6.8002L5.99995 6.8002L5.99995 8.0002L7.19995 8.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.52bf186cd64546c8bd06050cf52df8ef.svg";
export { ForwardRef as ReactComponent };